import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class LogLoader extends Loader {}

export const logLoader = new LogLoader({
  service: SERVICES.log,
})
